/**
 * Restructed by he.zhikai
 * Restructed on 2017-11-16
 */
'use strict';
angular.module('printGroupsModule', []).
controller('printGroupsCtrl', ["$scope", "$state", "$modalInstance", "commandService", "trsspliceString", "reports", "groupname", "title",
    function($scope, $state, $modalInstance, commandService, trsspliceString, reports, groupname, title) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                reports: reports,
                groupname: groupname,
                title: title,
                typeArr: ['普通', '重要', '紧急', '敏感'],
                channels: ['文字', '图片', '视频', '直播', '可视化', 'H5', 'VR'],
                printTypes: [{
                    name: "打印列表",
                    value: 0
                }, {
                    name: "打印详情",
                    value: 1
                }, {
                    name: "不打印",
                    value: 2
                }]
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            for (var i = 0; i < $scope.data.reports.length; i++) {
                $scope.data.reports[i].printType = 0;
                $scope.data.reports[i].executorlist = $scope.data.reports[i].EXECUTOR.length > 0 ? trsspliceString.spliceString($scope.data.reports[i].EXECUTOR, "USERNAME", ",") : "";
                var metaObj = $scope.data.reports[i].METATYPEINFO[0];
                $scope.data.reports[i].metatypeApp = metaObj.METATYPEBYAPP ? metaObj.METATYPEBYAPP.split(',').map(function(idx) {
                    return $scope.data.channels[parseInt(idx) - 1];
                }).concat(metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、') : (metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、');
                $scope.data.reports[i].metatypeWeb = metaObj.METATYPEBYWEB ? metaObj.METATYPEBYWEB.split(',').map(function(idx) {
                    return $scope.data.channels[parseInt(idx) - 1];
                }).concat(metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、') : (metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、');
                $scope.data.reports[i].metatypePaper = metaObj.METATYPEBYPAPER ? metaObj.METATYPEBYPAPER.split(',').map(function(idx) {
                    return $scope.data.channels[parseInt(idx) - 1];
                }).concat(metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、') : (metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、');
                $scope.data.reports[i].metatypeOther = metaObj.METATYPEBYOTHER;
            }
        }

        /**
         * [checkGroupPrint description] 校验报题、选题数量
         * @return {[type]} [description]
         */
        $scope.checkGroupPrint = function() {
            var needprint = false;
            angular.forEach($scope.data.reports, function(report) {
                if (report.printType != 2) {
                    needprint = true;
                }
            });
            return needprint;
        };
        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description] 确定
         * @return {[type]}      [description]
         */
        $scope.confirm = function() {
            LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                $('#printreportarea').jqprint({ importCSS: true });
            });
        };
    }
]);